import * as actions from '../actionTypes';
import { GET_SUBJECTS, ADD_SUBJECT, UPDATE_SUBJECT, DELETE_SUBJECT } from '../api';
import client from '../apolloClient';
import { deleteSubjectInstance } from './subjectInstanceActions';

export const deleteSubject = (subject_id) => async (dispatch, getState) => {
    try {
        const state = getState();

        const subject = state.subjects.find(sub => sub._id === subject_id);

         if (subject) {
            
            const subjectInstanceIds = state.subjectInstances
                .filter(subjin => subjin.subject.name=== subject.name)
                .map(subjin => subjin._id);
        
            const assignmentIds = state.assignments
                .filter(as => subjectInstanceIds.includes(as.subjectInstance._id))
                .map(as => as._id);

 
            const grades = state.grades.filter(gr =>
                assignmentIds.includes(gr.assignment)
            );

   
            const enrollmentIds = state.enrollments
                .filter(en => subjectInstanceIds.includes(en.subjectInstance._id))
                .map(en => en._id);

            const attendances = state.attendances.filter(at =>
                enrollmentIds.includes(at.enrollment._id)
            );

        


            assignmentIds.forEach(assignmentId => {
                const action = { type: actions.DELETE_ASSIGNMENT, payload: assignmentId };
                dispatch(action);
            });


            grades.forEach(grade => {
                const action = { type: actions.DELETE_GRADE, payload: grade._id };
                dispatch(action);
            });

            enrollmentIds.forEach(enrollmentId => {
                const action = { type: actions.DELETE_ENROLLMENT, payload: enrollmentId };
                dispatch(action);
            });

            attendances.forEach(attendance => {
                const action = { type: actions.DELETE_ATTENDANCE, payload: attendance._id };
                dispatch(action);
            });
            subjectInstanceIds.forEach(subjectInstanceId => {
                const action = { type: actions.DELETE_SUBJECT_INSTANCE, payload: subjectInstanceId };
                dispatch(action);
            });
        }

        await client.mutate({
            mutation: DELETE_SUBJECT,
            variables: { input: subject_id },
        });

        const action = { type: actions.DELETE_SUBJECT, payload: subject_id };
        dispatch(action);
    } catch (error) {
        console.error(error);
    }
};


export const setSubjects = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_SUBJECTS,
        });
        const subjects = data.subjects;
        const action = { type: actions.SET_SUBJECTS, payload: subjects };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const addSubject = (subject) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: ADD_SUBJECT,
            variables: { input: subject },
        });
        const savedSubject = data.createSubject;
        const action = { type: actions.ADD_SUBJECT, payload: savedSubject };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}


export const updateSubject = (subject) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_SUBJECT,
            variables: { input: subject },
        });
        const updatedSubject = data.updateSubject;
        const action = { type: actions.UPDATE_SUBJECT, payload: updatedSubject };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
